import { render, staticRenderFns } from "./invoice-annexure-2.vue?vue&type=template&id=1d0f1d9b&"
import script from "./invoice-annexure-2.vue?vue&type=script&lang=js&"
export * from "./invoice-annexure-2.vue?vue&type=script&lang=js&"
import style0 from "./invoice-annexure-2.vue?vue&type=style&index=0&id=1d0f1d9b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports